module.exports = __webpack_public_path__ + "static/media/Swarm.5ff57a63.png";